import browserLang from 'browser-lang';
import { getUrlParams } from './getUrlParams';

const languages = ['ru', 'en'];
export const fallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en';

export function getActiveLocale() {
  const locale =
    getLangFromUrl() || getLangFromBrowser() || process.env.VUE_APP_I18N_LOCALE || fallbackLocale;

  return locale;
}

function getLangFromUrl() {
  let { lang = '' } = getUrlParams();
  lang = lang.trim();

  if (!lang) {
    return undefined;
  }

  if (languages.includes(lang)) {
    return lang;
  }

  console.warn(`Unsupported language in url: ${lang}`);
}

function getLangFromBrowser() {
  return browserLang({
    languages,
    fallback: fallbackLocale,
  });
}
